<template>
  <div>
    <hb-data-table-header>
      <template v-slot:header> Company History </template>
      <template v-slot:description>
        All past end of months ran at the company level.
      </template>
    </hb-data-table-header>

    <v-card
      class="mt-0 mb-3"
      elevation="0"
    >
      <hb-data-table
        :headers="headers"
        :items="historyData"
      >
        <template v-slot:item.company_name="{ item }">
          {{ item.company_name }}
        </template>
        <template v-slot:item.period_start="{ item }">
          {{ item.period_start | changeDateTimeFormat("MMM, YYYY") }}
        </template>
        <template v-slot:item.closing_date="{ item }">
          <div>{{ item.closing_date | changeDateTimeFormat("MMMM D, YYYY") }}</div>
          <div>{{ item.closing_date | changeDateTimeFormat("h:mm A") }}</div>
        </template>
        <template v-slot:item.report="{ item }">
          <hb-btn
            v-if="item?.report_upload_id"
            prepend-icon="mdi-download"
            color="secondary"
            @click="onClickDownload(item)"
            >Download</hb-btn
          >
        </template>
      </hb-data-table>
    </v-card>
  </div>
</template>

<script type="text/babel">
import api from "../../assets/api.js";
import { downloadFile } from "../../utils/common.js";

export default {
  name: "HistoryTable",
  data() {
    return {
      historyData: [],
      headers: [
        { text: "Company Name", value: "company_name" },
        { text: "Month Closed", value: "period_start" },
        { text: "End Time", value: "closing_date" },
        { text: "Report", value: "report", sortable: false },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await api.get(this, api.END_OF_MONTH_COMPANY_HISTORY).then((r) => {
        this.historyData = r?.history;
      });
    },
    async onClickDownload(data) {
      if (!data?.report_upload_id) return;
      const { report_upload_id } = data;
      const response = await api.get(
        this.$app,
        `${api.REPORTS}generate-presigned-url/${report_upload_id}`
      );
      downloadFile({ url: response.url });
    },
  },
};
</script>

<style scoped></style>
